import useMutation from "src/hooks/useMutation";

function useCreateBulkReturnProcessing() {
  return useMutation({
    path: `/api/v1/return-logs`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs`,
      shouldRevalidate: true,
    },
  });
}

export default useCreateBulkReturnProcessing;
